module.exports = __webpack_public_path__ + "img/NL.6a9566f0.svg";